import { getmyWorksList } from "@/server/interfaces"
import resolveDefaultOpt from "@/utils/resolveDefaultOpt"

export default {
  namespaced: true,
  state: {
    myWorkList: [],
    noMoremyWorkList: false,
    modifyDetail: {}
  },
  getters: {
    myWorkList: state => state.myWorkList,
    noMoremyWorkList: state => state.noMoremyWorkList,
    modifyDetail: state => state.modifyDetail
  },
  mutations: {
    refreshmyWorkList(state, workList) {
      state.myWorkList = workList
    },
    savemyWorkList(state, workList) {
      state.myWorkList = [...state.myWorkList, ...workList]
    },
    setNoMoreWorksList(state, status) {
      state.noMoremyWorkList = status
    },
    modifyworkDetail(state, item) {
      item.mediaFiles = item.mediaFiles || []
      state.modifyDetail = item
      // window.console.log(state.modifyDetail)
    }
  },
  actions: {
    async getmyWorkList({ commit, rootState }, params) {
      const activityId = rootState.activityInfo.activityId
      // const activityId = "410774917178019840"
      params.params.activityId = activityId
      const {
        params: { page }
      } = params
      const { content: workList, last } = await getmyWorksList(params)
      workList.forEach(item => {
        Object.assign(item, item.defaultOpt, resolveDefaultOpt(item.defaultOpt))
        item.mediaFiles = item.mediaFiles || []
        item.videos = item.videos || []
        item.reviews = item.reviews || []
        const worksDefaultPic = item.worksDefaultPic
        const mediaFilesCoverItem = item.mediaFiles.find(item => item.cover)
        const mediaFilesCover = mediaFilesCoverItem ? mediaFilesCoverItem.url : ""
        const videoCover = item.videos[0] ? item.videos[0].coverImgUrl : ""
        const mediaDefaultCover = item.mediaFiles[0] ? item.mediaFiles[0].url : ""
        const cover = mediaFilesCover || videoCover || mediaDefaultCover || worksDefaultPic
        item.cover = cover
        item.mediaFiles = item.mediaFiles || []
        switch (item.reviewStatus) {
          case "WAIT":
            item.reviewStatusTxt = "待审核"
            break
          case "PASS":
            item.reviewStatusTxt = "审核通过"
            break
          case "REJECT":
            item.reviewStatusTxt = "审核未通过"
            break
          case "REVOKE":
            item.reviewStatusTxt = "审核未通过"
            break
        }
      })
      if (page === 0) {
        commit("refreshmyWorkList", workList)
      } else {
        commit("savemyWorkList", workList)
      }
      commit("setNoMoreWorksList", last)
    }
  }
}
